"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("qed");
var mobx_1 = require("mobx");
require("Project/Project.ng.html");
var Telemetry_1 = require("Telemetry");
var BoomerangHelper_1 = require("Instrumentation/BoomerangHelper");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var DashboardTypes_1 = require("@CommonFrontendBackend/Dashboard/DashboardTypes");
var DragStore_1 = require("Project/Stores/DragStore/DragStore");
var ContentSidebarMount_1 = __importDefault(require("./ContentSidebar/ContentSidebarMount"));
var EmptyProject_1 = require("./EmptyProject");
var PageQuoteTotalStore_1 = require("./Stores/PageQuoteTotalStore");
var ProjectStore_1 = __importDefault(require("./Stores/ProjectStore"));
var BlockDropPrompt_1 = require("./ContentSidebar/BlockDropPrompt");
var NavigationMenu_1 = require("./NavigationMenu/NavigationMenu");
var MountReactComponent_1 = __importDefault(require("@CommonFrontend/MountReactComponent/MountReactComponent"));
exports.default = angular.module("qwilr.project", ["ui.router"]).config(function ($stateProvider) {
    $stateProvider.state("project", {
        url: "/page/:id?source",
        params: {
            origin: null,
        },
        templateUrl: "Project/Project.ng.html",
        controller: function ($scope, $stateParams, mapControllers, $state, $timeout, $rootScope, $q) {
            var onLoaded;
            var di = $rootScope.di.child();
            di.invoke(function (projectService, loadingIndicator, usingFeature, createUi, userList, user, rootDataStore) {
                var pagePermissionsDataStore = rootDataStore.getPermissionsDataStore().getPagePermissions($stateParams.id);
                return $q
                    .all([projectService.getProject($stateParams.id), pagePermissionsDataStore.fetchData(true)])
                    .then(function (results) {
                    var project = results[0];
                    document.title = project.name;
                    $scope.project = project;
                    if (!projectService.isEditable($scope.project)) {
                        $state.go("projectView", { id: project._id });
                        di.get("notifyUser").warn("That project is not editable.");
                        return loadingIndicator.hide();
                    }
                    else if ($scope.project.usingNewEditor && usingFeature(FeatureFlag_1.FeatureFlag.OptOutNewEditor)) {
                        var showAcknowledgeModal = di.get("showAcknowledgeModal");
                        showAcknowledgeModal({
                            title: "This page can't be opened :(",
                            explainer: createUi(require("Common/ModalAngular/NewEditorModal/NewEditorModal.html")),
                            button: "Got it",
                        });
                        $state.go("dashboard", { nav: "pages" });
                        return loadingIndicator.hide();
                    }
                    else {
                        rootDataStore.pageFoldersDataStore.fetch();
                        di.load(require("./ProjectWiring")($scope.project, userList, user._id, rootDataStore, false, {
                            $scope: $scope,
                            $timeout: $timeout,
                        }));
                        return di.invoke(onLoaded);
                    }
                });
            });
            return (onLoaded = function (di, make, invoke, blockList, usingFeature, collaboration, $interval, loadingIndicator, projectEvents, blockBuilder, project, persist, projectNavigation, environment, notifyUser, apiBaseUrl, $http, projectStore, projectKeyboardShortcuts, blockCreator, savedBlockDragScroll, contentSidebarViewStore, dragStore, dropzonesStore, editorState, savedBlockDragDrop, accountQuoteSettings, variableService, discountService, billingScheduleOrchestrator, projectTelemetry, createUi, projectDimensionStore) {
                var _a;
                var _this = this;
                var canEdit = projectStore.isEditable;
                var user = di.get("user");
                projectTelemetry.projectOpened($stateParams, (_a = {},
                    _a[Telemetry_1.ProjectOpenedFields.AuthUserId] = user._id,
                    _a[Telemetry_1.ProjectOpenedFields.AccessLevel] = user._id === projectStore.user ? "owner" : projectStore.userAction,
                    _a[Telemetry_1.ProjectOpenedFields.AccessInFolder] = Boolean(projectStore.parentFolder),
                    _a));
                var stopDrop = function (e) {
                    if (usingFeature(FeatureFlag_1.FeatureFlag.OptOutNewEditor)) {
                        notifyUser.error("Sorry, we don't currently support drag and drop.");
                        return e.preventDefault();
                    }
                };
                document.addEventListener("drop", stopDrop);
                var attachOverlay = require("OverlayStack/Overlay.tsx").attachOverlay;
                var overlayStack = di.get("overlayStackReact");
                attachOverlay(overlayStack, $("#reactOverlayContainer")[0]);
                var pageQuoteTotalStore = new PageQuoteTotalStore_1.PageQuoteTotalStore(project, projectStore, accountQuoteSettings, variableService, discountService, billingScheduleOrchestrator, {
                    $scope: $scope,
                    $timeout: $timeout,
                });
                var mainNav = make(require("./TopNavigationBar/TopNavigationBar").default, { pageQuoteTotalStore: pageQuoteTotalStore });
                $scope.mainNav = mainNav.ui;
                $scope.hasInfoBanner = !canEdit;
                var loadingCheckPromise = null;
                var savedBlockDragHandler = function (event) {
                    if (event.target !== event.currentTarget) {
                        return;
                    }
                    if (!dragStore.dragItemIfCurrent(DragStore_1.DragType.SavedBlock)) {
                        return;
                    }
                    var lastBlockIndex = blockList.getLength();
                    (0, mobx_1.runInAction)(function () {
                        dropzonesStore.onOverDropzone(lastBlockIndex);
                    });
                    event.preventDefault();
                };
                var blockListElem = document.getElementsByClassName("block-list")[0];
                var pageContentElement = document.querySelector(".content-container__scroll-container");
                if (pageContentElement && typeof ResizeObserver !== "undefined") {
                    var pageContentResizeObserver_1 = new ResizeObserver(function (entries) {
                        if (entries.length > 0) {
                            var width = entries[0].contentBoxSize[0].inlineSize;
                            pageContentElement.style.setProperty("--page-content-width", "".concat(width, "px"));
                            projectDimensionStore.pageContentWidth = width;
                        }
                    });
                    pageContentResizeObserver_1.observe(pageContentElement);
                    $scope.$on("$destroy", function () {
                        pageContentResizeObserver_1.unobserve(pageContentElement);
                    });
                }
                $scope.initialBlockAddedToEmptyProject = false;
                (function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!!($scope.project.blocks != null ? $scope.project.blocks.length : undefined)) return [3, 3];
                                if ($scope.project.blocks == null) {
                                    $scope.project.blocks = [];
                                }
                                if (!usingFeature(FeatureFlag_1.FeatureFlag.Sidebar)) return [3, 2];
                                return [4, blockCreator.createAndInsert(BlockTypes_1.BlockType.Text, 0)];
                            case 1:
                                _a.sent();
                                return [3, 3];
                            case 2:
                                blockList.createBlockBrowserAfter(null, "no-scroll-to");
                                _a.label = 3;
                            case 3:
                                $scope.initialBlockAddedToEmptyProject = true;
                                return [2];
                        }
                    });
                }); })();
                var loadingCheck = function () {
                    var e_1, _a;
                    var allRendered = true;
                    try {
                        for (var _b = __values(Array.from($scope.project.blocks)), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var block = _c.value;
                            if (!block.$initialRenderComplete) {
                                allRendered = false;
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    if (allRendered && $scope.initialBlockAddedToEmptyProject) {
                        BoomerangHelper_1.BoomerangHelper.notifyClientPageLoaded("".concat(project._id));
                        editorState.startEditSession();
                        blockListElem.addEventListener("dragover", savedBlockDragHandler);
                        $interval.cancel(loadingCheckPromise);
                        return $timeout(function () {
                            $(document).scrollTop(0);
                            return loadingIndicator.hide();
                        }, 50);
                    }
                };
                loadingCheckPromise = $interval(loadingCheck, 50);
                var blockMenuActions = require("./BlockNew/Menu/EditorActions");
                var createBlockCtrl = function (block) {
                    return blockBuilder({
                        block: block,
                        autoPersist: block.type !== "Browser",
                        blockMenuActions: blockMenuActions,
                    });
                };
                $scope.blockUis = mapControllers($scope, createBlockCtrl, $scope.project.blocks);
                $scope.ui.navigationWidgets = {
                    header: invoke(require("./NavigationMenu/HeaderMenu/HeaderMenu")),
                    sidebar: invoke(require("./NavigationMenu/SidebarMenu/SidebarMenu")),
                };
                $scope.ui.isNavigationWidgetEnabled = function (type) { return canEdit && projectNavigation.isWidgetEnabled(type); };
                $scope.ui.isContentSidebarOpen = function () { return contentSidebarViewStore.isOpen; };
                var usingRefreshedNavigationMenu = usingFeature(FeatureFlag_1.FeatureFlag.RefreshedNavigationMenu);
                $scope.ui.usingRefreshedNavigationMenu = usingRefreshedNavigationMenu;
                $scope.ui.navigationHeader = usingRefreshedNavigationMenu
                    ? (0, NavigationMenu_1.mountNavigationHeader)((0, MountReactComponent_1.default)(createUi, di), {
                        $scope: $scope,
                        $timeout: $timeout,
                    }, pageQuoteTotalStore)
                    : undefined;
                $scope.ui.navigationDrawer = usingRefreshedNavigationMenu
                    ? (0, NavigationMenu_1.mountNavigationDrawer)((0, MountReactComponent_1.default)(createUi, di), { $scope: $scope, $timeout: $timeout })
                    : undefined;
                $scope.ui.isUsingTopNavigation = function () { var _a, _b, _c; return ((_c = (_b = (_a = $scope.project.settings) === null || _a === void 0 ? void 0 : _a.navigation) === null || _b === void 0 ? void 0 : _b.v2) === null || _c === void 0 ? void 0 : _c.layout) === "top"; };
                $scope.ui.isUsingFloatingNavigation = function () { var _a, _b, _c; return ((_c = (_b = (_a = $scope.project.settings) === null || _a === void 0 ? void 0 : _a.navigation) === null || _b === void 0 ? void 0 : _b.v2) === null || _c === void 0 ? void 0 : _c.layout) === "floating"; };
                $scope.$on("$destroy", function () {
                    $scope.ui.navigationHeader = undefined;
                    $scope.ui.navigationDrawer = undefined;
                });
                if (canEdit) {
                    make(persist, {
                        options: {
                            watchObject: "project.settings",
                            scope: $scope,
                            apiRoute: "".concat(apiBaseUrl, "/projects/").concat(project._id, "/settings"),
                            expectedSuccessMsg: "Project Settings Updated",
                        },
                    });
                }
                if (usingFeature(FeatureFlag_1.FeatureFlag.PersistenceSafetyNet)) {
                    invoke(require("./QwilrEditorV0/SafetyNet"));
                }
                if (usingFeature(FeatureFlag_1.FeatureFlag.UseRightToLeftBeta)) {
                    if ($scope.project.settings == null) {
                        $scope.project.settings = {
                            localisation: {
                                language: "English",
                                direction: "ltr",
                            },
                        };
                    }
                    di.value("localisationSettings", $scope.project.settings.localisation);
                }
                if (!usingFeature(FeatureFlag_1.FeatureFlag.OptOutNewEditor) && !$scope.project.usingNewEditor) {
                    $scope.project.usingNewEditor = true;
                    $http.post("".concat(apiBaseUrl, "/projects/").concat(project._id), { usingNewEditor: true });
                }
                projectKeyboardShortcuts.bind();
                $scope.$on("$destroy", function () { return projectKeyboardShortcuts.unbind(); });
                $scope.$on("$destroy", function () {
                    document.removeEventListener("drop", stopDrop);
                    blockListElem.removeEventListener("dragover", savedBlockDragHandler);
                    return projectEvents.emit("closed");
                });
                if (canEdit) {
                    collaboration.subscribe($scope);
                }
                if (environment !== "production") {
                    console.debug("Project: ", project);
                }
                if (canEdit && usingFeature(FeatureFlag_1.FeatureFlag.Sidebar)) {
                    $scope.sidebar = di.invoke(ContentSidebarMount_1.default);
                    $scope.blockDropPrompt = di.invoke(BlockDropPrompt_1.mountBlockDropPrompt);
                    $scope.emptyProject = di.invoke(EmptyProject_1.mountEmptyProject);
                    savedBlockDragScroll.bind();
                    savedBlockDragDrop.bind();
                    $scope.$on("$destroy", function () {
                        savedBlockDragScroll.unbind();
                        savedBlockDragDrop.unbind();
                    });
                }
            });
        },
    });
    return $stateProvider
        .state("savedBlock", {
        url: "/block/:action/:entityId/:currentFolder",
        templateUrl: "Project/Project.ng.html",
        controller: function ($stateParams, $state, $rootScope) {
            var di = $rootScope.di.child();
            var currentFolder = $stateParams === null || $stateParams === void 0 ? void 0 : $stateParams.currentFolder;
            return di.invoke(function (account, userList, user, savedBlockDataStore, rootDataStore, usingFeature, overlayStack, savedBlockService) {
                var isUsingNewEditor = usingFeature(FeatureFlag_1.FeatureFlag.NewEditor);
                var isOptOutNewEditor = usingFeature(FeatureFlag_1.FeatureFlag.OptOutNewEditor);
                var dummyProject = {
                    blocks: [],
                    links: [
                        {
                            secret: "",
                        },
                    ],
                    usingNewEditor: isUsingNewEditor && !isOptOutNewEditor,
                    usingTCDC: account.styleVersion === 2,
                };
                di.load(require("./ProjectWiring")(dummyProject, userList, user._id, rootDataStore, true, { disableSync: true }));
                var action = $stateParams.action;
                var entityId = $stateParams.entityId;
                var savedBlock = null;
                if (action === "new") {
                    savedBlock = savedBlockService.initialiseNewSavedBlock(entityId);
                    savedBlock.parentFolder =
                        currentFolder === DashboardTypes_1.SavedBlockCollection.All || !currentFolder ? null : currentFolder;
                }
                else {
                    savedBlock = savedBlockDataStore.getSavedBlockById(entityId);
                }
                if (!savedBlock) {
                    var showAcknowledgeModal = di.get("showAcknowledgeModal");
                    showAcknowledgeModal({
                        title: "We can't find the block :(",
                        explainer: "It looks like the block's id is incorrect",
                        button: "Got it",
                    });
                    $state.go("dashboard", { nav: "blocks" });
                    return;
                }
                var savedBlockOpener = di.get("savedBlockOpener");
                if ($stateParams.action === "preview") {
                    return savedBlockOpener.preview(savedBlock, "dashboard");
                }
                else if ($stateParams.action === "edit") {
                    return savedBlockOpener.edit(savedBlock, "dashboard");
                }
                else if ($stateParams.action === "new") {
                    return savedBlockOpener.edit(savedBlock, "dashboard", true);
                }
                else {
                    overlayStack.closeCurrent();
                }
            });
        },
    })
        .state("projectAction", {
        url: "/page/:id/:action",
        templateUrl: "Project/Project.ng.html",
        controller: function ($rootScope, $state, $stateParams) {
            return $rootScope.di.invoke(function (projectService, loadingIndicator, state, projectApiService, pageResourceApiService, projectTelemetry, user, rootDataStore, genericHost) {
                return projectService.getProject($stateParams.id).then(function (project) {
                    var projectStore = new ProjectStore_1.default(project, projectApiService, pageResourceApiService, user, projectTelemetry, rootDataStore, genericHost);
                    loadingIndicator.hide();
                    if (["share", "pdf", "analytics"].includes($stateParams.action)) {
                        return state.goToProjectAction($stateParams.action, projectStore, "project");
                    }
                    else {
                        return $state.go("dashboard", { nav: "pages" });
                    }
                });
            });
        },
    })
        .state("projectOld", {
        url: "/project/:id",
        templateUrl: "Project/Project.ng.html",
        controller: function ($location, $stateParams) {
            return $location.path("/page/".concat($stateParams.id));
        },
    })
        .state("projectActionOld", {
        url: "/project/:id/:action",
        templateUrl: "Project/Project.ng.html",
        controller: function ($location, $stateParams) {
            return $location.path("/page/".concat($stateParams.id, "/").concat($stateParams.action));
        },
    });
});
